import { isset } from '@/core/utils'

export const fetch = () => {
    
    const hash = window.location.hash.replace('#', '').split('&');

    let params = {};

    hash.length && hash.forEach(item => {

        const data = item.split('=');

        if(data.length == 2) params[data[0]] = data[1];
    });

    return params || {};
};

export const get = (widget, arg) => {

    let args = {};
    
    let params = fetch();

    if(params.$) try {

        args = JSON.parse(decodeURIComponent(params.$));
    }
    catch(e) {}

    if(!args[widget]) args[widget] = {};

    const res = {
        ...((!arg ? args[widget] : args[widget][arg]) || {})
    };

    return !Object.keys(res).length ? null : res;
};

export const set = (widget, arg, value) => {

    let args = fetch();

    let params = [];

    for(let key in args) if(key != '$') params.push(`${key}=${args[key]}`);

    let parsed = {};
    
    if(args.$) try {

        parsed = JSON.parse(decodeURIComponent(args.$));
    }
    catch(e) {}

    if(!parsed[widget]) parsed[widget] = {};
    else for(let i in parsed[widget]) if(!isset(parsed[widget][i])) delete parsed[widget][i];

    if(value) parsed[widget][arg] = value;

    params.push(`$=${(JSON.stringify(parsed || {}))}`);

    window.location.hash = params.join('&');
};

export const reset = () => set();

export default {
    get,
    set,
    reset
}





